import { openBankingService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    excelRequests: {data: []},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, statistics) {
        state.status    = 'success'
    },
    fail(state) {
        state.status    = 'fail'
    },
    setExcelRequests(state , response) {
        state.excelRequests = response.data
        state.status    = 'success'
    }
}

const getters = {
    status: state => state.status,
    excelRequests: state => state.excelRequests,
}

const actions = {
    fetchCoreExcelRequests({commit} , query){
        commit('loading')
        return openBankingService.fetchCoreExcelRequests(query)
            .then(response => {
                commit('setExcelRequests' , response.data)
            })
    },
    fetchCoreExcelTransfer({commit} , query){
        commit('loading')
        return openBankingService.fetchCoreExcelTransfer(query)
            .then(response => {
                commit('setExcelRequests' , response.data)
            })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}